// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__-yB5D","navigate_table":"styles_navigate_table__2oDMp","search_block":"styles_search_block__GEEoE","calendar":"styles_calendar__v+2g5"};